<template>
  <div>
    <el-card shadow="always">
      <DetailForm
        ref="detailForm"
        :shipmentPayStatementCode="shipmentPayStatementCode"
        :shipmentPayStatementStatus.sync="shipmentPayStatementStatus"
      />
      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          type="primary"
          size="small"
          @click="reviewApproved()"
          v-if="shipmentPayStatementStatus === 'S'"
        >
          {{ $l('INDEX.btn_reviewApproved') || '审核通过' }}
        </el-button>
        <el-button
          type="warning"
          size="small"
          @click="rejectReview()"
          v-if="
            shipmentPayStatementStatus === 'S' ||
              shipmentPayStatementStatus === 'Y'
          "
        >
          {{ $l('INDEX.Rejected') || '驳回' }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import DetailForm from '../components/detail-form'
import EditLoading from '@/mixins/edit-loading'
export default {
  name: 'transport-shipmentPayStatementReview-detail',
  components: { DetailForm },
  mixins: [EditLoading],
  computed: {
    params() {
      return this.$route.params
    },
    shipmentPayStatementCode() {
      return this.params.code
    },
  },
  data() {
    return { shipmentPayStatementStatus: '' }
  },
  methods: {
    reviewApproved() {
      if (!this.shipmentPayStatementCode) return
      this.$confirm(
        this.$l('tips_confirm_reviewApproved') || '是否允许该结算单审核通过？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .shipmentPayStatementReviewApprovedApi({
            shipmentPayStatementCode: this.shipmentPayStatementCode,
          })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (200 !== status) {
          this.$message.error('审核失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '审核成功！',
          type: 'success',
        })
        this.$refs.detailForm.getData()
      })
    },
    rejectReview() {
      if (!this.shipmentPayStatementCode) return
      this.$confirm(
        this.$l('tips_confirm_rejectReview') || '是否驳回该结算单审核申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .shipmentPayStatementRejectReviewApi({
            shipmentPayStatementCode: this.shipmentPayStatementCode,
          })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (200 !== status) {
          this.$message.error('驳回失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '驳回成功！',
          type: 'success',
        })
        this.$refs.detailForm.getData()
      })
    },
  },
}
</script>
